import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vorbasseSocket from "@/plugins/vorbasseSocket";
import vorbasseShopWp from "@/plugins/vorbasseShopWp";
import guloggratisApi from "@/plugins/GuloggratisApi";
import Clipboard from 'v-clipboard'
import {setCookie} from "@/helperFunctions";
import VueAnalytics from 'vue-analytics'
Vue.use(vorbasseSocket);
Vue.use(vorbasseShopWp);
Vue.use(guloggratisApi);
Vue.use(Clipboard);

Vue.use(VueAnalytics, {
	id: 'UA-165040354-2',
	router,
	autoTracking: {
		pageviewTemplate (route) {
			return {
				page: route.path,
				title: route.path,
				location: window.location.href
			}
		}
	}
})

if(location.href.indexOf('vb_ac=yes') !== -1)
{
	setCookie('vb_ac','y',24*365);
}

Vue.config.productionTip = false
window.resourcesData = {};
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
